import { schedularTherapistFilterAction } from './constant';

export const setTherapistFilterAction = (therapists: any, discipline: any) => {
  return {
    type: schedularTherapistFilterAction.SET_THERAPIST_FILTER_IN_SCHUDLAR,
    payload: { therapists, discipline },
  };
};

export const resetTherapistFilterAction = (discipline: string) => {
  return {
    type: schedularTherapistFilterAction.RESET_THERAPIST_FILTER_IN_SCHUDLAR,
    payload: { discipline },
  };
};

export const maintainTherapistFilterAction = (
  therapists: any,
  discipline: any,
  therapistId: any
) => {
  return {
    type: schedularTherapistFilterAction.MAINTAIN_THERAPIST_FILTER_REQUEST,
    payload: { therapists, discipline, therapistId },
  };
};

export const getAllMaintainedTherapistAction = (discipline: string, therapistId: any) => {
  return {
    type: schedularTherapistFilterAction.GET_ALL_MAINTAINED_THERAPISTS_REQUEST,
    payload: { therapistId, discipline },
  };
};

export const resetAllMaintainedTherapistAction = () => {
  return {
    type: schedularTherapistFilterAction.GET_ALL_MAINTAINED_THERAPISTS_RESET,
  };
};
